const scheduledServicesOutput = {
  title: `Services to be performed`,
  title1: `Overdue Services`
};

export default scheduledServicesOutput;
